
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.742 24.047a10.242 10.242 0 01-4.673.919 7.628 7.628 0 01-5.914-2.346A8.876 8.876 0 012 16.369a9.476 9.476 0 012.422-6.748 8.216 8.216 0 016.285-2.588 11.151 11.151 0 014.035.641v3.761A6.839 6.839 0 0011 10.395a4.813 4.813 0 00-3.712 1.535 5.9 5.9 0 00-1.413 4.159A5.8 5.8 0 007.209 20.1a4.57 4.57 0 003.59 1.493 7.319 7.319 0 003.943-1.113zM17.112 14.829v-2.344h2.344v2.344H21.8v2.343h-2.344v2.343h-2.344v-2.343H14.77v-2.344l2.342.001zM25.313 14.829v-2.344h2.344v2.344H30v2.343h-2.343v2.343h-2.344v-2.343h-2.342v-2.344l2.342.001z","fill":"#984c93"}})])
          )
        }
      }
    